import type { IconSvgObject } from './types';

const CalendarSearchIcon: IconSvgObject = [
  ["path", { d: "M16 2V6M7 2V6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5 12V6C20.5 4.89543 19.6046 4 18.5 4H4.5C3.39543 4 2.5 4.89543 2.5 6V20C2.5 21.1046 3.39543 22 4.5 22H11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.5 10H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M20 20.5L21.5 22M20.5 18C20.5 19.6569 19.1569 21 17.5 21C15.8431 21 14.5 19.6569 14.5 18C14.5 16.3431 15.8431 15 17.5 15C19.1569 15 20.5 16.3431 20.5 18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CalendarSearchIcon;
